import styled from '@emotion/styled';

export const Sidebar = styled('aside')`
  width: 100%;
  border-right: 1px solid #ede7f3;
  height: 100vh;
  overflow: auto;
  position: fixed;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: sticky;
  top: 0rem;
  padding-top: 28px;

  background: ${(props) => props.theme.colors.background};

  .rightSideTitle {
    font-weight: 400;
    font-size: 10px;
    line-height: 1px;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    padding: 13px 24px 25px 0px;

    color: rgba(47, 48, 55, 0.5);
  }

  .rightSideBarUL {
    margin-top: 60px;
  }

  .rightSideBarUL li {
    list-style-type: none;
    border-bottom: 0.5px solid rgba(47, 48, 55, 0.3);
    margin-right: 40px;
  }

  .rightSideBarUL li a {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    padding: 13px 24px 13px 0px;

    color: gray;
  }

  @media only screen and (max-width: 50rem) {
    width: 100%;
    position: relative;
  }
`;

export const ListItem = styled(({ className, active, level, ...props }) => {
  return (
    <li className={className}>
      <a href={props.to} {...props}>
        {props.children}
      </a>
    </li>
  );
})`
  list-style: none;

  a {
    color: #5c6975;
    text-decoration: none;
    font-weight: ${({ level }) => (level === 0 ? 700 : 400)};
    padding: 0.45rem 0 0.45rem ${(props) => 2 + (props.level || 0) * 1}rem;
    display: block;
    position: relative;

    &:hover {
      color: #7b68e3 !important;
    }

    ${(props) =>
      props.active &&
      `
      color: #7B68E3 !important;
      background-color: #fff;
    `} // external link icon
    svg {
      float: right;
      margin-right: 1rem;
    }
  }
`;
